import { isValidElement, type ReactNode } from "react";

export const getTextFromNode = (node: ReactNode, joinWith = ""): string => {
    if (typeof node === "string" || typeof node === "number") {
        return String(node);
    }

    if (Array.isArray(node)) {
        return node.map(item => getTextFromNode(item, joinWith)).join(joinWith);
    }

    if (isValidElement<{ children?: ReactNode; text?: string; }>(node)) {
        if (node.props.text) {
            return getTextFromNode(node.props.text, joinWith);
        }

        return getTextFromNode(node.props.children, node.type === "ul" ? "\n" : joinWith).replaceAll("  ", " ");
    }

    return "";
};
